import { memo } from 'react';

import { ClockIcon } from '@air/design-icons';

import {
  DiscussionMetadata,
  type DiscussionMetadataProps,
} from '~/components/DiscussionsV2/Discussion/DiscussionComment/components/DiscussionMetadata';
import { formatDiscussionTimestamp } from '~/components/DiscussionsV2/Discussion/DiscussionComment/components/formatDiscussionTimestamp';

export type CommentTimestampInfoProps = Pick<DiscussionMetadataProps, 'color'> & {
  endTimestamp?: number;
  timestamp: number;
};

export const CommentTimestampInfo = memo(({ color, endTimestamp, timestamp }: CommentTimestampInfoProps) => {
  return (
    <DiscussionMetadata color={color} Icon={ClockIcon} text={formatDiscussionTimestamp({ endTimestamp, timestamp })} />
  );
});

CommentTimestampInfo.displayName = 'CommentTimestampInfo';
